import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import { AuthProvider } from "./Auth/useAuth";
import Academicsession from "./Pages/Academicsession";
import Dashboard from "./Pages/Dashboard";
import DashboardHome from "./Pages/DashboardHome";
import DashboardPage from "./Pages/DashboardPage";
import FeeStructure from "./Pages/FeeStructure";
import HomePage from "./Pages/HomePage";
import IndoorGames from "./Pages/IndoorGames";
import DanceRooms from "./Pages/DanceRooms";
import MusicRooms from "./Pages/MusicRooms";
import Library from "./Pages/Library";
import LoginPage from "./Pages/LoginPage";
import Modal from "./Pages/Modal";
import AdminPage from "./AdminSection/AdminPage";
import AdminDashboard from "./AdminSection/AdminDashboard";
import TeachersField from "./AdminSection/TeachersField";
import AddTeachers from "./AdminSection/AddTeachers";
import Images from "./Pages/Images";
import TeachersPage from "./TeacherSection/TeachersPage";
import TeachersDashboard from "./TeacherSection/TeachersDashboard";
import Location from "./Pages/Location";
import RegisterPage from "./Pages/RegisterPage";
import StudentFields from "./TeacherSection/StudentFields";
import DetailsDashboard from "./AdminSection/DetailsDashboard";
import BarCharts from "./Charts/BarChart";
import PieCharts from "./Charts/PieChart";
import TeachersProfile from "./TeacherSection/TeachersProfile";
import AddingStudent from "./AdminSection/AddingStudent";
import StudentsField from "./AdminSection/StudentsField";
import UpdateSyllabus from "./TeacherSection/UpdateSyllabus";
import Crousel from "./component/Crousel";
import UpdateStudents from "./AdminSection/UpdateStudents";
import SchoolLeavingCertificate from "./AdminSection/SchoolLeavingCertificate";
import DownloadTC from "./AdminSection/DownloadTC";
import ShowingSLC from "./AdminSection/ShowingSLC";
import UpdateTeacher from "./AdminSection/UpdateTeacher";
import StudentResult from "./AdminSection/StudentResult";
import ShowResult from "./AdminSection/ShowResult";
import DownloadResult from "./AdminSection/DownloadResult";
import UpdateResult from "./AdminSection/UpdateResult";
import AllStudentResult from "./AdminSection/AllStudentResult";
import NoticeBoard from "./AdminSection/NoticeBoard";
import ShowNotice from "./AdminSection/ShowNotice";
import NoticePeople from "./AdminSection/NoticePeople";
import ResultStudentTerm1 from "./TeacherSection/ResultStudentTerm1";
import ResultShowTerm1 from "./TeacherSection/ResultShowTerm1";
import ResultUpdate from "./TeacherSection/ResultUpdate";
import ResultDownload from "./TeacherSection/ResultDownload";
import ParticularStudentResult from "./Pages/ParticularStudentResult";
import ProfilePage from "./Pages/ProfilePage";
import AdmissionStudent from "./AdminSection/AdmissionStudent";
import TextInputComponent from "./component/TextInputComponent";
import LoadingComponent from "./component/LoadingComponent";
import AttendanceDetails from "./TeacherSection/AttendanceDetails";
import StudentDetailsAll from "./AdminSection/StudentDetailsAll";
import SchoolManagementCommittee from "./Pages/SchoolManagementCommittee";
import StudentVerification from "./Pages/StudentVerification";
import AdministratorStudentVerification from "./AdminSection/AdministratorStudentVerification";
import ResultStudentTerm2 from "./TeacherSection/ResultStudentTerm2";
import UploadSyllabus from "./AdminSection/UploadSyllabus";
import AboutUs from "./Pages/AboutUs";
import GallerySection from "./component/GallerySection";
import ShowToppers from "./TeacherSection/ShowToppers";
import SyllabusPdf from "./AdminSection/SyllabusPdf";
import DetailsComponent from "./component/DetailsComponent";
import UpdateNotice from "./AdminSection/UpdateNotice";
import LabsSchool from "./Pages/LabsSchool";
import StudentAttendance from "./AdminSection/StudentAttendance";
import OutdoorGames from "./Pages/OutdoorGames";
import NavbarComponent from "./component/NavbarComponent";
import HeaderNavComponenet from "./component/HeaderNavComponenet";
import SecondTextInputComponent from "./component/SecondTextInputComponent";
import HolidaysList from "./Pages/HolidaysList";
import AssignedStudent from "./AdminSection/AssignedStudent";
import BookList from "./Pages/BookList";
import Activities from "./Pages/Activities";
import MandatoryDisclosure from "./Pages/MandatoryDisclosure";
import CBPpage from "./Pages/CBPpage";

function App() {
  const ScrollTop = (props) => {
    const location = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
    return props.children;
  };

  return (
    <Router>
      <ScrollTop>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="home" element={<HomePage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="location" element={<Location />} />
            <Route path="/img" element={<Images />} />
            <Route path="/feestructure" element={<FeeStructure />} />
            <Route path="/acadenicsession" element={<Academicsession />} />
            <Route path="/indoorgames" element={<IndoorGames />} />
            <Route path="/dancerooms" element={<DanceRooms />} />
            <Route path="/library" element={<Library />} />
            <Route path="/musicrooms" element={<MusicRooms />} />
            <Route path="/crousel" element={<Crousel />} />
            <Route path="/gallerySection" element={<GallerySection />} />
            <Route path="noticePeople" element={<NoticePeople />} />
            <Route path="bookList" element={<BookList />} />
            <Route path="cbp" element={<CBPpage />} />
            <Route
              path="mandatoryDisclosure"
              element={<MandatoryDisclosure />}
            />
            <Route
              path="studentVerification"
              element={<StudentVerification />}
            />
            <Route
              path="schoolManagementCommittee"
              element={<SchoolManagementCommittee />}
            />
            <Route path="uploadSyllabus" element={<UploadSyllabus />} />
            <Route path="aboutUs" element={<AboutUs />} />
            <Route path="labsSchool" element={<LabsSchool />} />
            <Route path="outdoorGames" element={<OutdoorGames />} />
            <Route path="navbarComponent" element={<NavbarComponent />} />
            <Route
              path="headerNavComponenet"
              element={<HeaderNavComponenet />}
            />
            <Route path="holidaysList" element={<HolidaysList />} />
            <Route path="activities" element={<Activities />} />

            <Route path="/dashboard" element={<DashboardPage />}>
              <Route path="" element={<Navigate to="dash" />} />
              <Route path="dash" element={<Dashboard />} />
              <Route path="dashboardHome" element={<DashboardHome />} />
              <Route path="modal" element={<Modal />} />
              <Route
                path="particularStudentResult"
                element={<ParticularStudentResult />}
              />
              <Route path="profilePage" element={<ProfilePage />} />
              <Route path="detailsComponent" element={<DetailsComponent />} />
            </Route>

            <Route path="/adminPage" element={<AdminPage />}>
              <Route path="" element={<Navigate to="adminDashboard" />} />
              <Route path="adminDashboard" element={<AdminDashboard />} />
              <Route path="teachersField" element={<TeachersField />} />
              <Route path="addTeacher" element={<AddTeachers />} />
              <Route path="detailsdashboard" element={<DetailsDashboard />} />
              <Route path="barcharts" element={<BarCharts />} />
              <Route path="piecharts" element={<PieCharts />} />
              <Route path="addingStudent" element={<AddingStudent />} />
              <Route path="studentsfield" element={<StudentsField />} />
              <Route path="updateStudents" element={<UpdateStudents />} />
              <Route
                path="schoolleavingcertificate"
                element={<SchoolLeavingCertificate />}
              />
              <Route path="downloadTC" element={<DownloadTC />} />
              <Route path="showingSLC" element={<ShowingSLC />} />
              <Route path="updateTeacher" element={<UpdateTeacher />} />
              <Route path="studentResult" element={<StudentResult />} />
              <Route path="showResult" element={<ShowResult />} />
              <Route path="downloadResult" element={<DownloadResult />} />
              <Route path="updateResult" element={<UpdateResult />} />
              <Route path="allStudentResult" element={<AllStudentResult />} />
              <Route path="noticeBoard" element={<NoticeBoard />} />
              <Route path="showNotice" element={<ShowNotice />} />
              <Route path="admissionStudent" element={<AdmissionStudent />} />
              <Route
                path="textInputComponent"
                element={<TextInputComponent />}
              />
              <Route path="loadingComponent" element={<LoadingComponent />} />
              <Route path="studentDetailsAll" element={<StudentDetailsAll />} />
              <Route
                path="administratorStudentVerification"
                element={<AdministratorStudentVerification />}
              />
              <Route path="syllabusPdf" element={<SyllabusPdf />} />
              <Route path="updateNotice" element={<UpdateNotice />} />
              <Route path="studentAttendance" element={<StudentAttendance />} />
              <Route path="assignedStudent" element={<AssignedStudent />} />
              <Route
                path="secondTextInputComponent"
                element={<SecondTextInputComponent />}
              />
            </Route>

            <Route path="/teacherspage" element={<TeachersPage />}>
              <Route path="" element={<Navigate to="teachersdashboard" />} />
              <Route path="teachersdashboard" element={<TeachersDashboard />} />
              <Route path="studentfield" element={<StudentFields />} />
              <Route path="teachersprofile" element={<TeachersProfile />} />
              <Route path="updatesyllabus" element={<UpdateSyllabus />} />
              <Route
                path="resultStudentTerm1"
                element={<ResultStudentTerm1 />}
              />
              <Route path="resultShowTerm1" element={<ResultShowTerm1 />} />
              <Route path="resultUpdate" element={<ResultUpdate />} />
              <Route path="resultDownload" element={<ResultDownload />} />
              <Route path="attendanceDetails" element={<AttendanceDetails />} />
              <Route
                path="resultStudentTerm2"
                element={<ResultStudentTerm2 />}
              />
              <Route path="showToppers" element={<ShowToppers />} />
            </Route>
          </Routes>
        </AuthProvider>
      </ScrollTop>
    </Router>
  );
}

export default App;
